import React from 'react';
import { HeroSection } from './components/HeroSection';
import { RealityCheckSection } from './components/RealityCheckSection';
import { WhySection } from './components/WhySection';
import { PromiseSection } from './components/PromiseSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStackSection } from './components/ValueStackSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofNotification } from './components/SocialProofNotification';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFF8F0] font-['Inter']" data-id="element-0">
      {/* Sticky announcement bar */}
      <div className="fixed top-0 left-0 w-full bg-[#DC2626] text-white text-center text-sm font-bold py-2.5 z-50" data-id="element-1">
        Precio de lanzamiento · Solo por esta semana · $6.36 · Garantía de 7
        días
      </div>
      <div className="h-10" data-id="element-2" />
      <HeroSection data-id="element-3" />
      <RealityCheckSection data-id="element-4" />
      <WhySection data-id="element-5" />
      <PromiseSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <BenefitsSection data-id="element-8" />
      <ForWhoSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <ValueStackSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <CTASection variant="primary" data-id="element-13" />
      <FAQSection data-id="element-14" />
      <CTASection variant="final" data-id="element-15" />
      <Footer data-id="element-16" />
      <SocialProofNotification data-id="element-17" />
    </div>;
}